'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AsyncButton = function (_React$Component) {
  _inherits(AsyncButton, _React$Component);

  function AsyncButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AsyncButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AsyncButton.__proto__ || Object.getPrototypeOf(AsyncButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      asyncState: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AsyncButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isUnmounted = true;
    }
  }, {
    key: 'resetState',
    value: function resetState() {
      this.setState({
        asyncState: null
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _this2 = this;

      var clickHandler = this.props.onClick;
      if (typeof clickHandler === 'function') {
        this.setState({
          asyncState: 'pending'
        });

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var returnFn = clickHandler.apply(null, args);
        if (returnFn && typeof returnFn.then === 'function') {
          returnFn.then(function () {
            if (_this2.isUnmounted) {
              return;
            }
            _this2.setState({
              asyncState: 'fulfilled'
            });
          }).catch(function (error) {
            if (_this2.isUnmounted) {
              return;
            }
            _this2.setState({
              asyncState: 'rejected'
            });
            throw error;
          });
        } else {
          this.resetState();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this3 = this;

      var _props = this.props,
          children = _props.children,
          text = _props.text,
          pendingText = _props.pendingText,
          fulFilledText = _props.fulFilledText,
          rejectedText = _props.rejectedText,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          loadingClass = _props.loadingClass,
          fulFilledClass = _props.fulFilledClass,
          rejectedClass = _props.rejectedClass,
          disabled = _props.disabled,
          attributes = _objectWithoutProperties(_props, ['children', 'text', 'pendingText', 'fulFilledText', 'rejectedText', 'className', 'loadingClass', 'fulFilledClass', 'rejectedClass', 'disabled']);

      var asyncState = this.state.asyncState;

      var isPending = asyncState === 'pending';
      var isFulfilled = asyncState === 'fulfilled';
      var isRejected = asyncState === 'rejected';
      var isDisabled = disabled || isPending;
      var buttonText = void 0;

      if (isPending) {
        buttonText = pendingText;
      } else if (isFulfilled) {
        buttonText = fulFilledText;
      } else if (isRejected) {
        buttonText = rejectedText;
      }
      buttonText = buttonText || text;

      return _react2.default.createElement(
        'button',
        _extends({}, attributes, {
          className: (0, _utils.classNames)(className, (_classNames = {}, _defineProperty(_classNames, loadingClass, isPending), _defineProperty(_classNames, fulFilledClass, isFulfilled), _defineProperty(_classNames, rejectedClass, isRejected), _classNames)),
          disabled: isDisabled,
          onClick: function onClick(event) {
            return _this3.handleClick(event);
          }
        }),
        typeof children === 'function' ? children({
          buttonText: buttonText,
          isPending: isPending,
          isFulfilled: isFulfilled,
          isRejected: isRejected
        }) : children || buttonText
      );
    }
  }]);

  return AsyncButton;
}(_react2.default.Component);

exports.default = AsyncButton;


AsyncButton.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  className: _propTypes2.default.string,
  loadingClass: _propTypes2.default.string,
  fulFilledClass: _propTypes2.default.string,
  rejectedClass: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  text: _propTypes2.default.string,
  pendingText: _propTypes2.default.string,
  fulFilledText: _propTypes2.default.string,
  rejectedText: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

AsyncButton.defaultProps = {
  loadingClass: 'AsyncButton--loading',
  fulFilledClass: 'AsyncButton--fulfilled',
  rejectedClass: 'AsyncButton--rejected'
};